import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { StoreState } from "../../../../redux/storeState/storeState";
import InvoicesTable from "../table/InvoicesTable";
import ColumnFilter from "../../../companies/columnFilter/ColumnFilter";
import * as actions from "../../../../redux/invoices/invoicesActions";
import moment from "moment";
import CustomDateSelect from "../../../../components/form-input/multi-date-select";
import dateIcon from "../../../../assets/images/dateIcon.svg";
import InvoicesLogsModal from "./InvoicesLogsModal";

function Invoices({
  selectedOption,
  setSelectedOption,
  selectedDate,
  selectedValue,
  setselectedValue,
  slectedLable,
  setslectedLable,
  setSelectedDate,
  options,
}: any) {
  const [invoicesSearchText, setInvoicesSearchText] = useState("");
  const [invoices, setInvoices] = useState<any>([]);
  const [page, setpage] = useState(1);
  const [size, setsize] = useState(10);
  const [total, setTotal] = useState(1);
  const [columnDropdownOpen, setColumnDropdownOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState<any>({});
  const [invoiceLogsLimit, setInvoiceLogsLimit] = useState(10);

  const { companyInfo, allInvoices, totalCount, invoicePage, invoiceSize, invoiceLogs, totalLogsCount, invoiceLogsCount } = useSelector(
    (state: StoreState) => ({
      companyInfo: state.companies.companySideInfoData,
      allInvoices: state.invoices.invoices,
      totalCount: state.invoices.total,
      invoicePage: state.invoices.page,
      invoiceSize: state.invoices.size,
      invoiceLogs: state?.invoices?.invoiceLogs,
      totalLogsCount: state?.invoices?.totalLogsCount,
      invoiceLogsCount: state?.invoices?.invoiceLogsCount,
    }),
  );
  const dispatch: any = useDispatch();
  const columnSelectorRef: any = useRef();

  useEffect(() => {
    if (selectedDate?.startDate && selectedDate?.endDate) {
      let data = {
        page: page,
        size: size,
        searchText: invoicesSearchText,
        startDate: moment(selectedDate?.startDate).format("YYYY/MM/DD"),
        endDate: moment(selectedDate?.endDate).format("YYYY/MM/DD"),
        sortAt: selectedHeader?.sortAt,
        sortBy: selectedHeader?.sortBy,
      };
      dispatch(actions.getFilteredInvoices(companyInfo?.id, data));
    }
    //eslint-disable-next-line
  }, [page, size, dispatch]);

  const headerData = [
    {
      id: "1",
      isSelected: true,
      label: "Invoice No",
      value: "invoiceName",
      disabled: true,
      sortAt: "invoiceData.invoiceNumber",
      sortBy: "desc",
    },
    {
      id: "2",
      isSelected: true,
      label: "Date & Time",
      value: "createdDate",
      disabled: true,
      sortAt: "created_at",
      sortBy: "desc",
    },
    {
      id: "3",
      isSelected: true,
      label: "Invoice ID",
      value: "invoiceId",
      disabled: true,
      sortAt: "_id",
      sortBy: "desc",
    },
    {
      id: "4",
      isSelected: false,
      label: "Invoice UUID",
      value: "invoiceUuid",
      disabled: false,
      sortAt: "invoiceData.uuId",
      sortBy: "desc",
    },
    {
      id: "5",
      isSelected: false,
      label: "User Name",
      value: "userName",
      disabled: false,
      sortAt: "user.name.first",
      sortBy: "desc",
    },
    {
      id: "6",
      isSelected: false,
      label: "User ID",
      value: "userId",
      disabled: false,
      sortAt: "user.businessId",
      sortBy: "desc",
    },
    {
      id: "7",
      isSelected: false,
      label: "Store Name",
      value: "storeName",
      disabled: false,
      sortAt: "store.name",
      sortBy: "desc",
    },
    {
      id: "8",
      isSelected: false,
      label: "Store ID",
      value: "storeId",
      disabled: false,
      sortAt: "store.businessId",
      sortBy: "desc",
    },
    {
      id: "9",
      isSelected: false,
      label: "POS Name",
      value: "posName",
      disabled: false,
      sortAt: "pos.name",
      sortBy: "desc",
    },
    {
      id: "10",
      isSelected: false,
      label: "POS ID",
      value: "posId",
      disabled: false,
      sortAt: "pos.businessId",
      sortBy: "desc",
    },
    {
      id: "11",
      isSelected: false,
      label: "Type",
      value: "type",
      disabled: false,
      sortAt: "invoiceData.invoiceType",
      sortBy: "desc",
    },
    {
      id: "12",
      isSelected: true,
      label: "Status",
      value: "status",
      disabled: true,
      sortAt: "status",
      sortBy: "desc",
    },
  ];

  const [headData, setHeadData] = useState<any>([...headerData]);
  const [selectedHeader, setselectedHeader] = useState(headerData[0]);
  useEffect(() => {
    let refactoredData = allInvoices?.map((item: any) => {
      return {
        ...item,
        userName: `${item?.user?.name?.first} ${item?.user?.name?.last}`,
        userId: item?.user?.businessId,
        invoiceUuid: item?.invoiceData?.uuId,
        posName: item?.pos?.name,
        posId: item?.pos?.businessId,
        storeName: item?.store?.name,
        storeId: item?.store?.businessId,
        type: item?.invoiceData?.invoiceType,
        invoiceName: item?.invoiceData?.invoiceNumber,
        createdDate: moment(item?.created_at)?.format("DD MMM YYYY HH:mm:ss"),
        invoiceId: item?._id,
        status:
          item?.zatca?.reportedAt && item?.zatca?.reportingStatus === "REPORTED"
            ? "Approved"
            : item?.zatca?.reportingStatus === "NOT_REPORTED"
              ? "Rejected"
              : "-",
      };
    });

    setInvoices([...refactoredData]);
  }, [allInvoices]);

  useEffect(() => {
    setTotal(totalCount);
    setpage(invoicePage);
    setsize(+invoiceSize);

    // eslint-disable-next-line
  }, [totalCount]);

  const handleSearchInvoices = (() => {
    let timeoutId: NodeJS.Timeout | undefined;
    return (searchString: any) => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        let data = {
          page: page,
          size: size,
          searchText: searchString,
          startDate: moment(selectedDate?.startDate).format("YYYY/MM/DD"),
          endDate: moment(selectedDate?.endDate).format("YYYY/MM/DD"),
          sortAt: selectedHeader?.sortAt,
          sortBy: selectedHeader?.sortBy,
        };
        if (selectedDate?.startDate && selectedDate?.endDate) {
          setInvoicesSearchText(searchString);
          dispatch(actions.getFilteredInvoices(companyInfo?.id, data));
        }
      }, 200);
    };
  })();

  useEffect(() => {
    if (selectedDate?.startDate && selectedDate?.endDate) {
      let data = {
        page: page,
        size: size,
        searchText: invoicesSearchText,
        startDate: moment(selectedDate?.startDate).format("YYYY/MM/DD"),
        endDate: moment(selectedDate?.endDate).format("YYYY/MM/DD"),
        sortAt: selectedHeader?.sortAt,
        sortBy: selectedHeader?.sortBy,
      };

      dispatch(actions.getFilteredInvoices(companyInfo?.id, data));
    }
    //eslint-disable-next-line
  }, [selectedDate]);

  const handleSelectAllColumns = () => {
    let nonSelectedItem = headData?.filter((item: any) => !item?.disabled)?.filter((item: any) => !item?.isSelected)?.length > 0;
    let refactoredData = headData?.map((item: any) => {
      return { ...item, isSelected: nonSelectedItem ? true : item?.disabled ? true : false };
    });
    setHeadData([...refactoredData]);
  };
  const handleSelectColumn = (id: string) => {
    let refactoredData = headData?.map((item: any) => {
      return { ...item, isSelected: item?.id === id && !item?.disabled ? !item?.isSelected : item?.isSelected };
    });
    setHeadData([...refactoredData]);
  };

  const handleArrowSortClick = () => {
    if (selectedHeader.sortBy === "asc") {
      setselectedHeader({ ...selectedHeader, sortBy: "desc" });
    } else {
      setselectedHeader({ ...selectedHeader, sortBy: "asc" });
    }
  };

  const handleSort = (item: any) => {
    setselectedHeader(item);
    if (selectedHeader.value === item.value) {
      if (selectedHeader.sortBy === "asc") {
        setselectedHeader({ ...selectedHeader, sortBy: "desc" });
      } else {
        setselectedHeader({ ...selectedHeader, sortBy: "asc" });
      }
    }
  };

  useEffect(() => {
    let data = {
      page: page,
      size: size,
      searchText: invoicesSearchText,
      startDate: moment(selectedDate?.startDate).format("YYYY/MM/DD"),
      endDate: moment(selectedDate?.endDate).format("YYYY/MM/DD"),
      sortAt: selectedHeader?.sortAt,
      sortBy: selectedHeader?.sortBy,
    };
    if (selectedDate?.startDate && selectedDate?.endDate) {
      dispatch(actions.getFilteredInvoices(companyInfo?.id, data));
    }
    //eslint-disable-next-line
  }, [selectedHeader]);
  useEffect(() => {
    if (invoiceLogsCount) {
      setInvoiceLogsLimit(invoiceLogsCount);
    }
  }, [invoiceLogsCount]);

  const resetHandler = () => {
    setInvoicesSearchText("");
    if (selectedDate?.startDate && selectedDate?.endDate) {
      let data = {
        page: page,
        size: size,
        searchText: "",
        startDate: moment(selectedDate?.startDate).format("YYYY/MM/DD"),
        endDate: moment(selectedDate?.endDate).format("YYYY/MM/DD"),
        sortAt: selectedHeader?.sortAt,
        sortBy: selectedHeader?.sortBy,
      };

      dispatch(actions.getFilteredInvoices(companyInfo?.id, data));
    }
  };

  const handleOutsideClick = (event: any) => {
    if (columnSelectorRef.current && !columnSelectorRef.current.contains(event.target)) {
      setColumnDropdownOpen(false);
    }
  };

  React.useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (companyInfo && selectedInvoice) {
      dispatch(actions.getInvoiceLogsById(companyInfo?.id, selectedInvoice?._id, invoiceLogsLimit));
    }
    // eslint-disable-next-line
  }, [selectedInvoice]);

  const handleClickItem = (item: any) => {
    setSelectedInvoice(item);
  };
  const handleLoadMoreLogs = () => {
    dispatch(actions.getInvoiceLogsById(selectedInvoice?.company, selectedInvoice?._id, invoiceLogsLimit + 10));
  };
  return (
    <div>
      <div className="main-overview-wrap">
        <div className="title-subscription">Companies &gt; {companyInfo?.businessName} &gt; Invoices</div>
        <button
          className="back-btn"
          onClick={() => {
            window.history.back();
          }}
        >
          Back
        </button>
        <div className="company-notifications h-100" style={{ position: "relative", minWidth: "25%" }}>
          <div className="date-wrapper px-2">
            <div>
              {selectedDate.startDate}-{selectedDate.endDate}
            </div>
            <div>
              <img src={dateIcon} alt="date icon" onClick={() => setIsOpen(!isOpen)} />
            </div>
          </div>
          <CustomDateSelect
            setselectedValue={setselectedValue}
            selectedValue={selectedValue}
            options={options}
            setslectedLable={setslectedLable}
            slectedLable={slectedLable}
            setSelectedDate={setSelectedDate}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />
        </div>
      </div>

      <div className="subscription-id">Business ID {companyInfo?.businessId}</div>
      <div style={{ position: "relative" }}>
        <InvoicesTable
          setSelectedOption={setSelectedOption}
          tableHeadData={headData}
          tableBodyData={invoices}
          page={+page}
          size={Number(size)}
          setPage={setpage}
          setSize={setsize}
          total={total}
          handleSiteSearch={handleSearchInvoices}
          handleArrowSortClick={handleArrowSortClick}
          handleSort={handleSort}
          searchText={invoicesSearchText}
          selectedHeader={selectedHeader}
          setsiteSearchText={setInvoicesSearchText}
          subscriptionView={false}
          placeholder="Search invoices"
          //  singleDetailPath={``}
          singleDetailPath="none"
          resetHandler={resetHandler}
          columnDropdownOpen={columnDropdownOpen}
          setColumnDropdownOpen={setColumnDropdownOpen}
          handleClickItem={handleClickItem}
        />
        <div ref={columnSelectorRef}>
          {columnDropdownOpen ? (
            <ColumnFilter
              columnHeaders={headData}
              setColumnHeaders={setHeadData}
              isHeaderSelected={columnDropdownOpen}
              handleSelectAllColumns={handleSelectAllColumns}
              handleSelectColumn={handleSelectColumn}
              isInvoiceComponent={true}
            />
          ) : null}
          {selectedInvoice && selectedInvoice?._id ? (
            <InvoicesLogsModal
              show={selectedInvoice?._id}
              onHide={() => setSelectedInvoice(null)}
              invoiceData={selectedInvoice}
              invoiceLogs={invoiceLogs}
              handleLoadMoreLogs={handleLoadMoreLogs}
              totalLogsCount={totalLogsCount}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default Invoices;
